var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24","width":"24","viewBox":"0 0 24 24","fill":"currentColor"}},_vm.$listeners),[_c('path',{attrs:{"d":"M22 4V2H2v2zM22 20v2H2v-2h9V9.83l-5.5 5.5-1.42-1.41L12 6l7.92 7.92-1.42 1.41-5.5-5.5V20z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }